import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../utils/rel';
import { getHotCarRank, getHotPicRank } from '../../../../../services/api';
import Title from '../../../components/title';
import SubTitle from '../../../components/subtitle';
import PropTypes from 'prop-types';

class RankList extends React.PureComponent {
    static propTypes = {
        hotArticleRank: PropTypes.object,
    };
    state = {
        hotCarRank: [],
        hotPicRank: [],
    };

    async componentDidMount() {
        try {
            let hotCarRank = await getHotCarRank();
            let hotPicRank = await getHotPicRank();

            this.setState({
                hotCarRank,
                hotPicRank,
            });
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const { hotArticleRank } = this.props;
        const { hotCarRank, hotPicRank } = this.state;

        return (
            <div className={styles.rank}>
                <Title content="排行" />

                <div className={styles.ranking_content}>
                    <div className={styles.ranking_item}>
                        <div className={styles.title}>热文排行榜</div>
                        <ul className={styles.list}>
                            {hotArticleRank &&
                                hotArticleRank.toplist.rec.map((item, index) => (
                                    <li key={index}>
                                        <span className={styles.num}>{index + 1}</span>
                                        <span className={styles.tit}>
                                            <a href={item.url} target="_blank" rel={rel}>
                                                {item.title}
                                            </a>
                                        </span>
                                        <span className={styles.view}>
                                            <i className={styles.athm_iconfont} />
                                            {(item.num / 10000).toFixed(2)}万
                                        </span>
                                    </li>
                                ))}
                        </ul>
                    </div>

                    <div className={styles.ranking_item}>
                        <div className={styles.title}>热车排行榜</div>
                        <ul className={styles.list}>
                            {hotCarRank &&
                                hotCarRank.length > 0 &&
                                hotCarRank.splice(0, 10).map((item, index) => (
                                    <li key={index} className={styles.second_li}>
                                        <span className={styles.num}>{index + 1}</span>
                                        <span className={styles.tit}>
                                            <a href={item.serialUrl} target="_blank" rel={rel}>
                                                {item.standardName}
                                            </a>
                                        </span>
                                        <span className={styles.view}>{item.guidePrice}万</span>
                                    </li>
                                ))}
                        </ul>
                    </div>

                    <div className={styles.ranking_item}>
                        <div className={styles.title}>热图排行榜</div>
                        <ul className={styles.list}>
                            {hotPicRank &&
                                hotPicRank.length > 0 &&
                                hotPicRank.splice(0, 10).map((item, index) => (
                                    <li key={index}>
                                        <span className={styles.num}>{index + 1}</span>
                                        <span className={styles.tit}>
                                            <a href={item.url} target="_blank" rel={rel}>
                                                {item.title}
                                            </a>
                                        </span>
                                        <span className={styles.view}>
                                            <i className={styles.athm_iconfont} />
                                            {(item.num / 10000).toFixed(2)}万
                                        </span>
                                    </li>
                                ))}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(RankList);
